(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-love-laugh"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ll-about').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const gallery = root.querySelector('[data-gallery]');
    const galleryTrack = root.querySelector('[data-gallery-track]');
    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const progress = root.querySelector('[data-gallery-progress]');
    const mobileGallery = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let galleryFrame = null;

    const moveGallery = (direction) => {
      const card = gallery.querySelector('.ll-about__gallery-card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(gallery).columnGap) || 18;
      gallery.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    const updateProgress = () => {
      const maximum = gallery.scrollWidth - gallery.clientWidth;
      const percentage = maximum > 0 ? 20 + (gallery.scrollLeft / maximum) * 80 : 100;
      progress.style.width = `${Math.min(100, percentage)}%`;
    };

    const updateMobileGallery = () => {
      galleryFrame = null;
      if (!mobileGallery.matches || reducedMotion.matches) return;
      const maximum = gallery.scrollWidth - gallery.clientWidth;
      const verticalDistance = galleryTrack.offsetHeight - window.innerHeight;
      const travelled = Math.min(verticalDistance, Math.max(0, -galleryTrack.getBoundingClientRect().top));
      gallery.scrollLeft = verticalDistance > 0 ? (travelled / verticalDistance) * maximum : 0;
      updateProgress();
    };

    const requestGalleryUpdate = () => {
      if (galleryFrame !== null) return;
      galleryFrame = window.requestAnimationFrame(updateMobileGallery);
    };

    const configureMobileGallery = () => {
      if (!mobileGallery.matches || reducedMotion.matches) {
        galleryTrack.style.removeProperty('--ll-gallery-track-height');
        return;
      }
      const horizontalDistance = Math.max(0, gallery.scrollWidth - gallery.clientWidth);
      galleryTrack.style.setProperty('--ll-gallery-track-height', `${window.innerHeight + horizontalDistance}px`);
      requestGalleryUpdate();
    };

    previous.addEventListener('click', () => moveGallery(-1));
    next.addEventListener('click', () => moveGallery(1));
    gallery.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('scroll', requestGalleryUpdate, { passive: true });
    window.addEventListener('resize', configureMobileGallery, { passive: true });
    mobileGallery.addEventListener('change', configureMobileGallery);
    reducedMotion.addEventListener('change', configureMobileGallery);
    gallery.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', configureMobileGallery, { once: true });
    });
    configureMobileGallery();
    updateProgress();

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });

      root.querySelectorAll('.ll-about__reveal').forEach((element) => observer.observe(element));
    } else {
      root.querySelectorAll('.ll-about__reveal').forEach((element) => element.classList.add('is-visible'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
